module.exports = __webpack_public_path__ + "img/user.6911ff2f.svg";